import React from 'react';
import {
  AUTH_ERROR_TITLE,
  AUTH_ERROR_SUBTITLE,
  AUTH_ERROR_RETRY_BTN,
  COPYWRIGHT_TEXT,
  FOOTER_LINK_1,
  FOOTER_LINK_2,
  FOOTER_LINK_3,
} from 'src/constants/constant';

interface AuthErrorProps {
  onRetry: () => void;
}

export default function AuthError({ onRetry }: AuthErrorProps): JSX.Element {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-white">
      <header>
        <img
          src='/assets/images/DataViewLogo.png'
          alt='logo'
          width={160}
          height={100}
          className='logo'
        />
      </header>

      <div className="border-b w-full" style={{ borderColor: '#d3d3d3' }}></div>

      <main className="flex flex-1 items-center justify-center px-4">
        <div className="container max-w-[370px] mx-auto flex flex-col items-center text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#FEF3C7] mb-[20px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#D97706"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
              <path d="M12 9v4" />
              <path d="M12 17h.01" />
            </svg>
          </div>
          <h1 className="text-[20px] font-bold text-muted mb-[10px]">
            {AUTH_ERROR_TITLE}
          </h1>
          <p className="text-subtitle text-[14px] mb-[35px]">
            {AUTH_ERROR_SUBTITLE}
          </p>
          <button
            onClick={onRetry}
            className="btn bg-gradient-to-b border-0 from-red to-primary h-[30px] w-[70%] text-14 capitalize focus-visible:outline-none rounded-50 font-semibold hover:from-[#D6242C] hover:to-[#ED4B52] text-white"
          >
            {AUTH_ERROR_RETRY_BTN}
          </button>
        </div>
      </main>

      <footer className='w-full flex flex-col sm:flex-row justify-between items-center px-[50px] py-[20px] mt-auto bg-white'>
        <div className='flex justify-start sm:justify-center items-center mb-[10px] sm:mb-0'>
          <p className='text-muted2 text-12'>{COPYWRIGHT_TEXT}</p>
        </div>
        <div>
          <a
            href='https://www.healthlinkdimensions.com/website-terms'
            target='_blank'
            rel='noopener noreferrer'
            className='text-muted2 text-12 hover:text-primary pr-4 border-r border-muted2 pt-0 pb-0'
          >
            {FOOTER_LINK_1}
          </a>
          <a
            href='https://www.healthlinkdimensions.com/privacy-policy'
            target='_blank'
            rel='noopener noreferrer'
            className='text-muted2 text-12 hover:text-primary pr-4 pl-4 border-r border-muted2 pt-0 pb-0'
          >
            {FOOTER_LINK_2}
          </a>
          <a
            href='https://www.healthlinkdimensions.com/consumerprivacyrights'
            target='_blank'
            rel='noopener noreferrer'
            className='text-muted2 text-12 hover:text-primary pl-4'
          >
            {FOOTER_LINK_3}
          </a>
        </div>
      </footer>
    </div>
  );
}
